module.exports = __webpack_public_path__ + "img/rate_smile.d2948176.svg";